"use strict";
var ComponentStore_1 = require("./ComponentStore");
/**
 * Sets the Armature attributes of a given class.
 */
function Attributes(data) {
    return function (target) {
        target.prototype.template = data.template;
        target.htmlTagName = data.tag;
        if (data.classes) {
            target.htmlClassNames = target.htmlClassNames.concat(data.classes);
        }
        ComponentStore_1.default.register(target);
    };
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Attributes;

//# sourceMappingURL=Attributes.js.map
